module.exports = __webpack_public_path__ + "img/mute.9f76de7f.png";